import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ReactGA from 'react-ga';

const useStyles = makeStyles((theme) => ({
    right: {
        paddingLeft: "1rem"
    },
    start: {},
    element: {
        marginBottom: "1rem",
        marginTop: "1rem"
    },
    container: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: "2rem",
        width: "400px",
        maxWidth: "100%"
        // marginTop: '50%', transform: 'translateY(-50%)',
    },
    root: {
        width: "100%",
    }
}));

function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}



const Steps = ({active, info, state, change}) => {
    const [value, setValue] = React.useState({phone: ""});
    const getBattery = (battery) => info.front.products.batteryTypes.find(b => b.ID === battery)
    const getWallbox = (wallbox) => info.front.products.wallboxTypes.find(w => w.ID === wallbox)

    React.useEffect(() => {
        ReactGA.event({
            category: 'Calc',
            action: 'Final'
          });
    }, [])

    const contact = (contactInstructions) => {
        change({...info, ...value, contactInstruction: contactInstructions || (value.phone ? "Vill bli kontaktad via telefon" : "Vill bli kontaktad via email")})
        // eslint-disable-next-line no-undef
        // eslint-disable-next-line no-restricted-globals
        parent?.postMessage(
            {event: "Kontakta mig"},
            "https://kalkyl.solelgrossisten.se"
        );

    }

    const classes = useStyles();
    return <Container>
        <Grid container spacing={3} className={classes.container}>
            <Grid item xs={12}>
                {/* <Typography variant="h3" className={classes.element}>Sammanfattning</Typography> */}
                <Card className={classes.root}>

                    <CardContent>
                        <Typography gutterBottom variant="h5" component="h2">
                            Ditt tak
                        </Typography>
                        <Typography variant="body1" component="p">
                            {info.front.location.address}<br/>
                            {numberWithSpaces(info
                                .front
                                .productionYear
                                .toFixed(0))} kWh per år
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12}>
                {/* <Typography variant="h3" className={classes.element}>Sammanfattning</Typography> */}
                <Card className={classes.root}>

                    <CardContent>
                        <Typography gutterBottom variant="h5" component="h2">
                            Produkter
                        </Typography>
                        <Typography variant="body1" component="p">
                            Panel: {info.front.products.selectedPanelName}, {info.front.panelCount} <br/>
                           {info.front.optimizers.hasOptimizer != 0 && <>Optimerare: {info.front.products.selectedOptimizerName}, {info.front.optimizerCount} <br/></>}
                            Växelriktare: {info.front.products.selectedInverterName} <br/>
                            {getBattery(info?.front?.batteries[0]) && <>Batteri: {getBattery(info.front?.batteries[0])?.name} <br/></>}
                            {getWallbox(info?.front?.wallbox[0]) && <>Laddbox: {getWallbox(info.front?.wallbox[0])?.name} <br/></>}

                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item container xs={12}>
                <Card className={classes.root}>

                    <CardContent>
                        <Typography gutterBottom variant="h5" component="h2">
                            Potential
                        </Typography>
                        <Grid item container xs={12}>
                            <Grid item xs={6}>
                                <Typography variant="body1" component="p">
                                    Totalkostnad
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{textAlign: "right"}}>
                                {numberWithSpaces(info.front.cost.totalCost.toFixed(0))} SEK
                            </Grid>
                            {info?.front?.deduction?.selected?.name && info.front.deduction.selected.value < 0 && <><Grid item xs={6}>
                                <Typography variant="body1" component="p">
                                    {info.front.deduction.selected.name}

                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{textAlign: "right"}}>
                            <Typography variant="body1" component="p">
                                {numberWithSpaces(info.front.deduction.selected.value.toFixed(0))} SEK
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                            <Typography variant="body1" component="p">
                                Totalkostnad (efter avdrag)
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{textAlign: "right"}}>
                                <Typography variant="body1" component="p">
                                    {numberWithSpaces(info.front.cost.finalCost.toFixed(0))} SEK
                                </Typography>
                            </Grid></>}
                            <hr style={{width: "100%"}}/>
                            <Grid item xs={6}>
                                <Typography variant="body1" component="p">
                                Årlig inkomst
                            </Typography>
                            </Grid>
                            <Grid item xs={6} style={{textAlign: "right"}}>
                                <Typography variant="body1" component="p">
                                    {numberWithSpaces((info.front.sales.yearProductionValue.toFixed(0)))} SEK
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1" component="p">
                                    Återbetalningstid
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{textAlign: "right"}}>
                                <Typography variant="body1" component="p">
                                    {info.front.yearEarning} år
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item container xs={12}>
                <Card className={classes.root}>

                    <CardContent>
                        <Typography gutterBottom variant="h5" component="h2">
                            {(info.front.phone || info.front.contactInstruction) ? "Tack!" : "Vill du bli kontaktad av en av våra rådgivare?"}
                        </Typography>
                        {!(info.front.phone || info.front.contactInstruction) && <Grid spacing={2} container><Grid item sm={12} xs={12}>
                            <TextField value={value.phone} onChange={event => setValue({phone: event.target.value, contactInstruction: "Vill bli kontaktad via telefon"})} fullWidth label="telefonnummer" className={classes.element}/>
                        </Grid>
                        <Grid item sm={12} xs={12}>
                            <TextField value={info.front.email} fullWidth label="email" className={classes.element}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Button color="primary" onClick={() => contact("Vill ha mer information")} fullWidth size="large" variant="outlined" className={classes.element}>Mer info</Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button color="primary" onClick={() => contact()} fullWidth size="large" variant="outlined" className={classes.element}>Ja tack!</Button>
                        </Grid></Grid>}
                        {(info.front.phone || info.front.contactInstruction) && 
                            <Typography variant="body1" component="p">
                                {info.front.contactInstruction === 'Vill ha mer info' ? 'Vi kommer att kontakta dig med mer information!' : 'Vi kommer att återkomma till dig för att skapa en mer detaljerad offert!'}
                                    
                            </Typography>
                        }
                    </CardContent>
                </Card>
            </Grid>

        </Grid>
    </Container>

};

export default Steps;